// extracted by mini-css-extract-plugin
export default {"root":"links_root__TZAa8","container":"links_container__rFQiR","listBlock":"links_listBlock__6y7m2","list":"links_list__9iQ1Y"};